import React from 'react';
import './SectionCard.css';

/**
 * SectionCard — standardised card wrapper used for dashboard stat blocks,
 * module overview cards, and list panels.
 *
 * Usage:
 *   <SectionCard title="Fire Safety" icon={<FaFire />} badge={3} actions={<button>...</button>}>
 *     {children}
 *   </SectionCard>
 */
const SectionCard = ({
  title,
  subtitle,
  icon,
  badge,
  badgeVariant = 'blue',  // 'blue' | 'red' | 'amber' | 'green' | 'gray'
  actions,
  children,
  noPad = false,
  className = '',
  onClick,
}) => {
  const Tag = onClick ? 'button' : 'div';

  return (
    <div className={`section-card ${className}`} style={onClick ? { cursor: 'pointer' } : undefined} onClick={onClick}>
      {(title || icon || actions) && (
        <div className="sc-header">
          <div className="sc-header-left">
            {icon && <span className="sc-icon">{icon}</span>}
            <div className="sc-title-group">
              {title && <h3 className="sc-title">{title}</h3>}
              {subtitle && <p className="sc-subtitle">{subtitle}</p>}
            </div>
          </div>
          <div className="sc-header-right">
            {badge !== undefined && badge !== null && (
              <span className={`sc-badge sc-badge-${badgeVariant}`}>{badge}</span>
            )}
            {actions && <div className="sc-actions">{actions}</div>}
          </div>
        </div>
      )}
      <div className={noPad ? '' : 'sc-body'}>
        {children}
      </div>
    </div>
  );
};

/**
 * StatCard — compact metric card (number + label + optional trend)
 */
export const StatCard = ({ value, label, icon, color = 'blue', trend, trendUp, className = '' }) => (
  <div className={`stat-card stat-card-${color} ${className}`}>
    {icon && <div className="stat-card-icon">{icon}</div>}
    <div className="stat-card-body">
      <div className="stat-card-value">{value}</div>
      <div className="stat-card-label">{label}</div>
      {trend !== undefined && (
        <div className={`stat-card-trend ${trendUp ? 'trend-up' : 'trend-down'}`}>
          {trendUp ? '↑' : '↓'} {trend}
        </div>
      )}
    </div>
  </div>
);

export default SectionCard;
